// src/api/auth.api.js
import { apiClient, handleGlobalLogout } from "./apiClient.js";

export const authApi = {
  // Login: Cookies are set automatically by backend in Set-Cookie header
  login: async (credentials) => {
    const response = await apiClient.post("/api/login", credentials);
    return response.data?.data !== undefined ? response.data.data : response.data;
  },

  // Refresh token manually (usually handled automatically by interceptor)
  refreshToken: async () => {
    const response = await apiClient.post("/api/refresh-token", {});
    return response.data?.data !== undefined ? response.data.data : response.data;
  },

  // Get current user profile
  getProfile: async () => {
    const response = await apiClient.get("/api/me");
    return response.data?.data !== undefined ? response.data.data : response.data;
  },

  // Logout: Revokes session in DB/Redis and clears cookies
  logout: async () => {
    try {
      await apiClient.post("/api/logout", {});
    } catch (e) {
      console.warn("Backend logout failed or offline:", e);
    } finally {
      handleGlobalLogout("user_logout");
    }
  },

  // Session Management
  getActiveSessions: async () => {
    const response = await apiClient.get("/api/auth/sessions");
    const sessions = response.data?.data !== undefined ? response.data.data : response.data;
    return Array.isArray(sessions) ? sessions : [];
  },

  revokeSession: async (sessionId) => {
    const response = await apiClient.post("/api/auth/sessions/revoke", { sessionId });
    return response.data;
  },

  revokeAllOtherSessions: async () => {
    const response = await apiClient.post("/api/auth/sessions/revoke-all-others", {});
    return response.data;
  },

  // Role Metadata for User Management
  getRoles: async () => {
    const response = await apiClient.get("/api/roles");
    return response.data?.data !== undefined ? response.data.data : response.data;
  },
};

export default authApi;
